import * as React from 'react';
import { Dialog } from "@progress/kendo-react-dialogs";
import { getIdpClients, getIdpMappers, getCurrentIdpClientsManagement, editClient, createClient, getPortalClientID } from '../../ApiUtils/ApiUtils';
import { MouseEventHandler } from 'react';


export interface KeycloakClient {
    id: string;
    clientId: string;
    name: string;
    description: string;
    rootUrl: string;
    baseUrl: string;
    surrogateAuthRequired: boolean;
    enabled: boolean;
    alwaysDisplayInConsole: boolean;
    clientAuthenticatorType: string;
    redirectUris: string[];
    webOrigins: string[];
    notBefore: number;
    bearerOnly: boolean;
    consentRequired: boolean;
    standardFlowEnabled: boolean;
    implicitFlowEnabled: boolean;
    directAccessGrantsEnabled: boolean;
    serviceAccountsEnabled: boolean;
    publicClient: boolean;
    frontchannelLogout: boolean;
    protocol: string;
    attributes: {
        "id.token.as.detached.signature": string;
        "saml.assertion.signature": string;
        "saml.force.post.binding": string;
        "saml.multivalued.roles": string;
        "saml.encrypt": string;
        "oauth2.device.authorization.grant.enabled": string;
        "backchannel.logout.revoke.offline.tokens": string;
        "saml.server.signature": string;
        "saml.server.signature.keyinfo.ext": string;
        "use.refresh.tokens": string;
        "exclude.session.state.from.auth.response": string;
        "oidc.ciba.grant.enabled": string;
        "saml.artifact.binding": string;
        "backchannel.logout.session.required": string;
        "client_credentials.use_refresh_token": string;
        "saml_force_name_id_format": string;
        "require.pushed.authorization.requests": string;
        "saml.client.signature": string;
        "tls.client.certificate.bound.access.tokens": string;
        "saml.authnstatement": string;
        "display.on.consent.screen": string;
        "saml.onetimeuse.condition": string;
    };
    authenticationFlowBindingOverrides: {};
    fullScopeAllowed: boolean;
    nodeReRegistrationTimeout: number;
    defaultClientScopes: string[];
    optionalClientScopes: string[];
    access: {
        view: boolean;
        configure: boolean;
        manage: boolean;
    }
    readOnly: boolean;
}

export interface DupeClient {
    clientId: string;
    name: string;
    enabled: boolean;
    alwaysDisplayInConsole: boolean;
}

export interface IdpMapper {
    id: string;
    name: string;
    identityProviderAlias: string;
    identityProviderMapper: string;
    config: {
        "attribute.value": string;
        "syncMode": string;
        "attribute": string;
    };
}

interface CompAppMapper {
    name: string;
    identityProviderAlias: string;
    identityProviderMapper: string;
    config: {
        "attribute.value": string;
        "syncMode": string;
        "attribute": string;
    };
}

interface ClientUpdate {
    enabled: boolean,
    alwaysDisplayInConsole: boolean,

}

const InitialState: {
    clients: KeycloakClient[];
    idpMappers: IdpMapper[];
    clientsInSelectedIDP: KeycloakClient[];
    portalClientId: string;
} = {
    clients: [],
    idpMappers: [],
    clientsInSelectedIDP: [],
    portalClientId: "",
}
type State = typeof InitialState;

type IdpConfigureFormProps = {
    configName: string;
    realmName: string;
    toggleDialog: () => void;
}

class IdpConfigureForm extends React.Component<IdpConfigureFormProps, State> {

    public constructor(props: IdpConfigureFormProps) {
        super(props);
        this.state = {
            clients: [],
            idpMappers: [],
            clientsInSelectedIDP: [],
            portalClientId: "",
        };
    }

    private getClients = async() => {
        await getIdpClients().then((dataArray) => {
            let dataArrayArray = JSON.parse(dataArray);
            for (let ind in dataArrayArray) {
                let idp = dataArrayArray[ind];
                idp.readOnly = false;
                if (this.props.configName == "GDSLINK_IDP" && idp.clientId == this.state.portalClientId) {
                    idp.readOnly = true;
                }
            }
            dataArray = JSON.stringify(dataArrayArray);
            this.setState({ clients: JSON.parse(dataArray) });
        });
    }
    private getPortalClientID = async() => {
        await getPortalClientID().then((data) => {
            this.setState({ portalClientId: data })
        });
    }

    private getMappers = async() => {
       await getIdpMappers(this.props.configName).then((dataArray) => {
            this.setState({ idpMappers: JSON.parse(dataArray) })
        });
    }

    private getRealmClients = async(realmName: string) => {
       await getCurrentIdpClientsManagement(realmName).then((dataArray) => {  
            this.setState({ clientsInSelectedIDP: JSON.parse(dataArray) });
        });
    }

    componentDidMount() {
        this.getPortalClientID().then(() => {
            this.getRealmClients(this.props.realmName).then(() => {
                this.getMappers().then(() => {
                    this.getClients();
                })
            })
        })
    }

    //This now needs to check if the client in the realm is ENABLED. If it is, check, if not check.
    private validateCheckboxes(clientName: string) {
        var realmClientNames: string[] = [];
        this.state.clientsInSelectedIDP.forEach((client) => {
            realmClientNames.push(client.clientId)
        })
        if (realmClientNames.indexOf(clientName) > -1) {
            return this.state.clientsInSelectedIDP[realmClientNames.indexOf(clientName)].enabled
        }
        return false;
    }

    private validateDisplayInConsoleCheckboxes(clientName: string) {
        var realmClientNames: string[] = [];
        this.state.clientsInSelectedIDP.forEach((client) => {
            realmClientNames.push(client.clientId)
        })
        if (realmClientNames.indexOf(clientName) > -1) {
            if (this.state.clientsInSelectedIDP[realmClientNames.indexOf(clientName)].enabled) {
                return this.state.clientsInSelectedIDP[realmClientNames.indexOf(clientName)].alwaysDisplayInConsole;
            }
            else {
                return false;
            }
        }
        return false;
    }

    private handleSubmit = () => {
        event?.preventDefault();
        //Need to get the selected realms clients. Loop over. Check if the client with ticked boxes are in realm. If not duplicate client from GDSAuth. Enabled = True
        var checkboxes = document.getElementsByClassName("allowAccessIDP");
        var tickedCheckBoxes = [];
        var untickedCheckBoxes = [];
        var realmClientNames: string[] = [];
        this.state.clientsInSelectedIDP.forEach((client) => {
            realmClientNames.push(client.clientId);

        })
        for (var i = 0; i < checkboxes.length; i++) {
            if ((checkboxes[i] as HTMLInputElement).checked) {
                tickedCheckBoxes.push((checkboxes[i] as HTMLInputElement).getAttribute("data-clientId"));
            }
            else {
                untickedCheckBoxes.push((checkboxes[i] as HTMLInputElement).getAttribute("data-clientId"));
            }
        }
        tickedCheckBoxes.forEach((ticked: string|null) => {
            //Loop over names in tickedCheckBoxes and add to make client in selected IDP enabled. 
            if (ticked) {
                if (realmClientNames.indexOf(ticked) > -1) {
                    const cli: ClientUpdate = {
                        enabled: true,
                        alwaysDisplayInConsole: (document.getElementById("alwaysDisplayInConsole" + ticked) as HTMLInputElement)?.checked,

                    }
                    editClient(cli, this.props.realmName, this.state.clientsInSelectedIDP[realmClientNames.indexOf(ticked)].id)
                }
                else {
                    this.state.clients.find((element) => {
                        if (element.clientId === ticked) {
                            const dupeCli = element;
                            const cli: DupeClient = {
                                name: dupeCli.name,
                                clientId: dupeCli.clientId,
                                enabled: true,
                                alwaysDisplayInConsole: true,
                            }
                            createClient(cli, this.props.realmName)
                        }
                    }, this)
                }
            }
        }, this)
        untickedCheckBoxes.forEach((unticked:string|null) => {
            //Loop over names in unticked checkboxes and make client in selected IDP disabled.
            if (unticked) {
                if (realmClientNames.indexOf(unticked) > -1) {
                    const cli: ClientUpdate = {
                        enabled: false,
                        alwaysDisplayInConsole: false
                    }
                    editClient(cli, this.props.realmName, this.state.clientsInSelectedIDP[realmClientNames.indexOf(unticked)].id)
                }
            }
        }, this)
        this.props.toggleDialog();
    }
    private handleEnabledClick = (pClientID?: string) => {
        var clientIsEnabled:boolean = (document.getElementById("allowAccess" + pClientID) as HTMLInputElement)?.checked;
        (document.getElementById("alwaysDisplayInConsole" + pClientID) as HTMLInputElement).checked = clientIsEnabled;
        (document.getElementById("alwaysDisplayInConsole" + pClientID) as HTMLInputElement).disabled = !clientIsEnabled;
    }

    public render() {
        return (
            <>
                <Dialog
                    title={"Applications access"}
                    onClose={() => this.props.toggleDialog()}
                    style={{ fontSize: "8px" }}
                    width={500}
                    height={"100%"}
                >
                    <form onSubmit={this.handleSubmit} style={{ fontSize: "11px", padding: "10px 15px 0px" }}>
                        {this.state.clients.map((client, i) => (
                        <>
                            {client.alwaysDisplayInConsole && (
                            <div key={client.id + "div"} className="companyApplicationAccess">
                                <div  >
                                            <h6>{client.name} </h6><br />( {client.clientId} )<br/>
                                        <span>{client.description}</span><br />
                                </div>
                                    <div className="allowaccess">
                                            <input key={"allowAccess" + client.clientId} data-clientID={client.clientId} type="checkbox" name={"allowAccess" + client.clientId} id={"allowAccess" + client.clientId} className="k-checkbox allowAccessIDP" style={{ width: "16px", height: "16px" }} disabled={client.readOnly} defaultChecked={this.validateCheckboxes(client.clientId)} onClick={() => this.handleEnabledClick(client.clientId)}/>
                                            <label htmlFor={"allowAccess" + client.clientId}>&nbsp;Allow access</label>
                                            <br />
                                            <input key={"alwaysDisplayInConsole" + client.clientId} data-clientID={client.clientId} type="checkbox" name={"alwaysDisplayInConsole" + client.clientId} id={"alwaysDisplayInConsole" + client.clientId} className="k-checkbox alwaysDisplayInConsoleIDP" style={{ width: "16px", height: "16px" }} disabled={client.readOnly || !this.validateCheckboxes(client.clientId)} defaultChecked={this.validateDisplayInConsoleCheckboxes(client.clientId)} />
                                            <label htmlFor={"alwaysDisplayInConsole" + client.clientId}>&nbsp;Displayed in portal</label>
                                    </div>
                            </div>
                                )}
                            </>
                        ))}
                        <input type="submit" value="Submit" className={"btn btn-primary"} style={{ marginRight: "10px" }} />
                        <button className={"btn btn-secondary"} style={{ marginRight: "15px" }} onClick={() => this.props.toggleDialog()}>Cancel</button>
                    </form>
                </Dialog>
            </>
        );
    }
}

export default IdpConfigureForm;